import { API_KEY_GET_BRAND_ITEM, GetBrandInfoRequest } from "../utils";
import { useQuery } from "react-query";
import { getBrandInfo } from "../api";

export const useGetBrandItem = (params: GetBrandInfoRequest) => {
  return useQuery([API_KEY_GET_BRAND_ITEM, params], () => getBrandInfo(params));
};
